import { GenericCrudPage } from '@/components/GenericCrudPage';
import { examSessionsConfig } from '@/pages/configs';

export default function ExamSessionsPage() {
  return <GenericCrudPage config={examSessionsConfig} />;
}
